import {
  Icon,
  Text,
  TextField,
  Label,
  DefaultButton,
  DetailsList,
  SelectionMode,
  PrimaryButton,
} from 'office-ui-fabric-react';
import React, { useRef } from 'react';
import { useCustomInput } from '../../common/custom-hooks/useCustomInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { Entrenador } from '../../system/Entrenador/Entrenador';
import { Jugador } from '../../system/Jugador/Jugador';
import { PlanillaPartidoJugador } from '../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import { PlanillaPartidoOficial } from '../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import { PlanillaPartidoOficialAuxiliar } from '../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import SystemClient from '../../system/SystemClient';
import DialogTemplate from '../Common/DialogTemplate';
import { EntrenadorCardForConfeccion } from '../PlanillaPartido/Programado/Confeccion/CardUtils/EntrenadorCardForConfeccion';
import PlanillaPartidoOfflineForm from './PlanillaPartidoOfflineForm';
import OficialOfflineForm from './OficialOfflineForm';
import InputField from '../../lib/FormValidator/Form/InputField';
import JugadorOfflineForm from './JugadorOfflineForm';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import { createArtificialId } from '../../common/utils';
import { JugadorCardForConfeccionOffline } from './JugadorCardForConfeccionOffline';
import OficialAuxiliarOfflineForm from './OficialAuxiliarOfflineForm';
import CustomForm from '../../lib/FormValidator/Form/CustomForm';

interface IConfeccionPlanillaPartidoTeamOffline {
  system: SystemClient;
  changeBlockUI: (state: boolean) => void;
  form: PlanillaPartidoOfflineForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  equipoId: string;
  club_nombre: string;
}
export const tipoDocumentoOptions = [
  { key: '1', text: 'DNI' },
  { key: '2', text: 'Pasaporte' },
];

export const MAX_HANDBALL_PLAYERS_PER_TEAM = 16;
export const MIN_HANDBALL_PLAYERS_PER_TEAM = 5;
const MAX_OFICIALES_AUXILIARES = 3;
const ConfeccionPlanillaPartidoTeamOffline = ({
  system,
  changeBlockUI,
  form,
  onBlurCustomInput,
  equipoId,
  club_nombre,
}: IConfeccionPlanillaPartidoTeamOffline) => {
  // ==========================================================================================
  // =================================== Forms e Inputs =======================================
  // ==========================================================================================
  const [jugadorFormIsValid, setJugadorFormIsValid] = React.useState(false);
  const [oficialFormIsValid, setOficialFormIsValid] = React.useState(false);
  const [oficialAuxiliarFormIsValid, setOficialAuxiliarFormIsValid] = React.useState(false);

  React.useEffect(() => {
    form.reinitializeJugadorAAgregarForm();
    form.reinitializeOficialAAgregarForm();
    form.reinitializeOficialAuxiliarAAgregarForm();
  }, []);

  const onBlurForm = (form: CustomForm, setter: (b: boolean) => void) => {
    setter(form.isValid());
  };

  const oficialesAuxiliaresInput = useCustomInput(() => form.getOficialesAuxiliaresInput(), [form]);
  const planillaPartidoJugadoresInput = useCustomInput(() => form.getPlanillaPartidoJugadoresInput(), [form]);
  const oficialesInput = useCustomInput(() => form.getOficialesInput(), [form]);

  const jugadorOfflineNombreInput = useCustomInput(
    () => form.getJugadorAAgregarForm().getNombreInput(),
    [form.getJugadorAAgregarForm()]
  );
  const jugadorOfflineApellidoInput = useCustomInput(
    () => form.getJugadorAAgregarForm().getApellidoInput(),
    [form.getJugadorAAgregarForm()]
  );
  const jugadorOfflineTipoDocInput = useCustomInput(
    () => form.getJugadorAAgregarForm().getTipoDocInput(),
    [form.getJugadorAAgregarForm()]
  );
  const jugadorOfflineNroDocInput = useCustomInput(
    () => form.getJugadorAAgregarForm().getNroDocInput(),
    [form.getJugadorAAgregarForm()]
  );

  const oficialOfflineNombreInput = useCustomInput(
    () => form.getOficialAAgregarForm().getNombreInput(),
    [form.getOficialAAgregarForm()]
  );
  const oficialOfflineApellidoInput = useCustomInput(
    () => form.getOficialAAgregarForm().getApellidoInput(),
    [form.getOficialAAgregarForm()]
  );
  const oficialOfflineTipoDocInput = useCustomInput(
    () => form.getOficialAAgregarForm().getTipoDocInput(),
    [form.getOficialAAgregarForm()]
  );
  const oficialOfflineNroDocInput = useCustomInput(
    () => form.getOficialAAgregarForm().getNroDocInput(),
    [form.getOficialAAgregarForm()]
  );

  const oficialAuxiliarOfflineNombreInput = useCustomInput(
    () => form.getOficialAuxiliarAAgregarForm().getNombreInput(),
    [form.getOficialAuxiliarAAgregarForm()]
  );
  const oficialAuxiliarOfflineApellidoInput = useCustomInput(
    () => form.getOficialAuxiliarAAgregarForm().getApellidoInput(),
    [form.getOficialAuxiliarAAgregarForm()]
  );
  const oficialAuxiliarOfflineOrdenInput = useCustomInput(
    () => form.getOficialAuxiliarAAgregarForm().getOrdenInput(),
    [form.getOficialAuxiliarAAgregarForm()]
  );
  const oficialAuxiliarOfflineNroDocInput = useCustomInput(
    () => form.getOficialAuxiliarAAgregarForm().getNroDocInput(),
    [form.getOficialAuxiliarAAgregarForm()]
  );

  // ==========================================================================================
  // ==========================================================================================
  // ==========================================================================================

  const [showFormAuxiliar, setShowFormAuxiliar] = React.useState<boolean>(false);
  const [showFormJugador, setShowFormJugador] = React.useState<boolean>(false);
  const [showErrorDialogDorsal, setShowErrorDialogDorsal] = React.useState<boolean>(false);
  const [showYaFueIngresadoJugadorDialog, setShowYaFueIngresadoJugadorDialog] =
    React.useState<boolean>(false);
  const [showYaFueIngresadoOfcAuxDialog, setShowYaFueIngresadoOfcAuxDialog] = React.useState<boolean>(false);
  const inputRefs = useRef([]);
  const changeDorsalByJugador = (jugId: string, nv: string) => {
    if (nv === '' || (+nv > 0 && +nv < 100)) {
      const planillaPartidoJugadores = [
        ...planillaPartidoJugadoresInput.getValue(),
      ] as PlanillaPartidoJugador[];

      console.log(planillaPartidoJugadores);

      const jugIdx = planillaPartidoJugadores.findIndex(
        (ppj) => +ppj.getJugid() === +jugId && ppj.isActive()
      );
      planillaPartidoJugadores[jugIdx].setDorsal(+nv);
      planillaPartidoJugadoresInput.setValue(planillaPartidoJugadores);
      planillaPartidoJugadoresInput.onBlur();
      onBlurCustomInput(planillaPartidoJugadoresInput);
    }
  };

  const onClickAddJugador = () => {
    // setShowFormJugador(false);
    const jugadorOffline = Jugador.fromOffline(
      createArtificialId().toString(),
      jugadorOfflineNombreInput.getValue(),
      jugadorOfflineApellidoInput.getValue(),
      jugadorOfflineTipoDocInput.getValue(),
      jugadorOfflineNroDocInput.getValue()
    );

    addJugadorToTeam(jugadorOffline);
    // setTimeout(() => {
    //   setJugadorFormIsValid(false);
    //   setShowFormJugador(true);
    // }, 50);
  };

  const addJugadorToTeam = async (jugador: Jugador) => {
    const planillaPartidoJugadores = [
      ...planillaPartidoJugadoresInput.getValue(),
    ] as PlanillaPartidoJugador[];

    if (
      planillaPartidoJugadores.filter(
        (jug: PlanillaPartidoJugador) =>
          jug.getEqid() === +equipoId &&
          jug.getJugador().getDocumentoNumero() === jugadorOfflineNroDocInput.getValue() &&
          jug.getJugador().getDtiid() === jugadorOfflineTipoDocInput.getValue()
      ).length > 0
    ) {
      // alert('ya esta');
      setShowYaFueIngresadoJugadorDialog(true);
    } else {
      planillaPartidoJugadores.push(
        PlanillaPartidoJugador.createFrom(
          createArtificialId().toString(),
          0,
          +equipoId,
          +jugador.getId()!,
          0,
          false,
          jugador,
          false
        )
      );
      planillaPartidoJugadoresInput.setValue(planillaPartidoJugadores);
      planillaPartidoJugadoresInput.onBlur();

      form.reinitializeJugadorAAgregarForm();
      onBlurForm(form.getJugadorAAgregarForm(), setJugadorFormIsValid);
    }

    onBlurCustomInput(planillaPartidoJugadoresInput);
  };

  const deleteAuxiliar = (item: any) => {
    const oficialesAuxiliares = [...oficialesAuxiliaresInput.getValue()] as PlanillaPartidoOficialAuxiliar[];
    const idx = oficialesAuxiliares.findIndex(
      (oa) =>
        oa.getNombre() === item.ppoa_nombre &&
        oa.getApellido() === item.ppoa_apellido &&
        oa.getDni() === item.ppoa_dni
    );
    if (idx > -1) {
      if (oficialesAuxiliares[idx].getId()) {
        oficialesAuxiliares[idx].setDeleted(true);
      } else {
        oficialesAuxiliares.splice(idx, 1);
      }
      oficialesAuxiliaresInput.setValue(oficialesAuxiliares);
    }
  };

  const onRender = (label: any) => {
    return <span style={{ fontSize: 16 }}>{label}</span>;
  };

  const columnsAux = [
    {
      key: 'ppoa_orden',
      name: 'Orden',
      fieldName: 'ppoa_orden',
      minWidth: 50,
      maxWidth: 50,
      onRender: (item: any) => onRender(`${item.ppoa_orden}`),
    },
    {
      key: 'ppoa_nombre',
      name: 'Oficial auxiliar',
      fieldName: 'ppoa_nombre',
      minWidth: 100,
      onRender: (item: any) => onRender(`${item.ppoa_apellido}, ${item.ppoa_nombre}`),
    },
    {
      key: 'ppoa_dni',
      name: 'DNI',
      fieldName: 'ppoa_dni',
      minWidth: 100,
      onRender: (item: any) => onRender(`${item.ppoa_dni}`),
    },
    {
      key: 'ppoa_id',
      name: '',
      fieldName: 'ppoa_id',
      onRender: (item: any) => {
        return (
          <Icon
            iconName="Trash"
            className="clickable"
            onClick={() => deleteAuxiliar(item)}
            style={{ fontSize: 16, color: '#cb0000' }}
          ></Icon>
        );
      },
      minWidth: 100,
    },
  ];

  const onClickAddOficial = () => {
    const oficialOffline = Entrenador.fromOffline(
      createArtificialId().toString(),
      oficialOfflineNombreInput.getValue(),
      oficialOfflineApellidoInput.getValue(),
      oficialOfflineTipoDocInput.getValue(),
      oficialOfflineNroDocInput.getValue()
    );
    addEntrenadorToTeam(oficialOffline);
    console.log(form);
  };

  const addEntrenadorToTeam = (entrenador: Entrenador) => {
    const oficiales = [...oficialesInput.getValue()] as PlanillaPartidoOficial[];
    oficiales.push(
      PlanillaPartidoOficial.createFrom('', 0, +equipoId, +entrenador.getId()!, entrenador, false)
    );
    oficialesInput.setValue(oficiales);
    form.reinitializeOficialAAgregarForm();
    onBlurForm(form.getOficialAAgregarForm(), setOficialFormIsValid);
  };

  const deleteEntrenador = (entrenador: Entrenador) => {
    const oficiales = [...oficialesInput.getValue()] as PlanillaPartidoOficial[];
    const idx = oficiales.findIndex((o) => o.isActive() && +o.getEntid() === +entrenador.getId()!);
    if (idx > -1) {
      if (oficiales[idx].getId()) {
        oficiales[idx].setDeleted(true);
      } else {
        oficiales.splice(idx, 1);
      }
      oficialesInput.setValue(oficiales);
    }
  };

  const deleteJugador = (jugador: Jugador) => {
    const planillaPartidoJugadores = [
      ...planillaPartidoJugadoresInput.getValue(),
    ] as PlanillaPartidoJugador[];

    const idx = planillaPartidoJugadores.findIndex((j) => +j.getJugid() === +jugador.getId()!);

    if (idx > -1) {
      if (planillaPartidoJugadores[idx].getId()) {
        planillaPartidoJugadores[idx].setDeleted(true);
      } else {
        planillaPartidoJugadores.splice(idx, 1);
      }
      planillaPartidoJugadoresInput.setValue(planillaPartidoJugadores);
      planillaPartidoJugadoresInput.onBlur();
      onBlurCustomInput(planillaPartidoJugadoresInput);
    }
  };

  const sameNumberChecker = (i: number) => {
    let isValid = true;

    const jugadores = [
      ...form
        .getPlanillaPartidoJugadoresInput()
        .getValue()
        .filter((ppj: PlanillaPartidoJugador) => ppj.isActive() && ppj.getDorsal()),
    ];

    jugadores.forEach((ppj: PlanillaPartidoJugador, idx1: number) => {
      jugadores.forEach((ppj2: PlanillaPartidoJugador, idx2: number) => {
        const hasRepeated =
          idx1 !== idx2 &&
          ppj2.isActive() &&
          !!ppj2.getDorsal() &&
          +ppj.getEqid() === +ppj2.getEqid() &&
          +ppj.getDorsal() === +ppj2.getDorsal();
        if (hasRepeated) {
          isValid = false;
        }
      });
    });

    if (!isValid) {
      setShowErrorDialogDorsal(true);
    }
  };

  const hasRepeated = (jugId: string, dorsal: number, eqId: string) => {
    const ppjList = [
      ...form
        .getPlanillaPartidoJugadoresInput()
        .getValue()
        .filter((ppj: PlanillaPartidoJugador) => ppj.isActive() && ppj.getDorsal()),
    ];
    return ppjList.some(
      (ppj) => +ppj.getDorsal() === +dorsal && +ppj.getJugid() !== +jugId && +ppj.getEqid() === +eqId
    );
  };

  const saveAuxiliar = () => {
    const oficialesAuxiliares = [...oficialesAuxiliaresInput.getValue()] as PlanillaPartidoOficialAuxiliar[];
    if (
      oficialesAuxiliares.filter(
        (of: PlanillaPartidoOficialAuxiliar) =>
          of.getEqid() === +equipoId && of.getDni() === oficialAuxiliarOfflineNroDocInput.getValue()
      ).length > 0
    ) {
      // alert('ya esta');
      setShowYaFueIngresadoOfcAuxDialog(true);
    } else {
      oficialesAuxiliares.push(
        form.getOficialAuxiliarAAgregarForm().toPlanillaPartidoOficialAuxiliar(+equipoId, 0)
      );
      oficialesAuxiliaresInput.setValue(oficialesAuxiliares);
      form.reinitializeOficialAuxiliarAAgregarForm();
      onBlurForm(form.getOficialAuxiliarAAgregarForm(), setOficialAuxiliarFormIsValid);
      cancelAuxiliar();
    }
  };

  const getOrdenesDisponibles = () => {
    const possibleOrden = ['B', 'C', 'D'];
    const oficialesAuxiliares = [...oficialesAuxiliaresInput.getValue()] as PlanillaPartidoOficialAuxiliar[];
    const oficialesAuxiliaresTeamOrdenes = oficialesAuxiliares
      .filter((o) => +o.getEqid() === +equipoId)
      .map((o) => o.getOrden());
    return possibleOrden
      .filter((po) => !oficialesAuxiliaresTeamOrdenes.includes(po))
      .map((o) => {
        return {
          key: o,
          text: o,
        };
      });
  };

  const cancelAuxiliar = () => {
    setShowFormAuxiliar(false);
  };

  const cancelJugador = () => {
    setShowFormJugador(false);
  };

  return (
    <>
      <DialogTemplate
        showDialog={showYaFueIngresadoJugadorDialog}
        toggleShowDialog={() => setShowYaFueIngresadoJugadorDialog(!showYaFueIngresadoJugadorDialog)}
        title={'Jugador previamente ingresado'}
        onAccept={() => {
          setShowYaFueIngresadoJugadorDialog(false);
        }}
        onCancel={() => {}}
        hideCancelButton
        acceptText={'Ok'}
        cancelText={'No'}
        minWidth={500}
      >
        <Text className="error-message" variant="medium">
          Ya fue ingresado un jugador con ese tipo y numero de documento
        </Text>
      </DialogTemplate>

      <DialogTemplate
        showDialog={showYaFueIngresadoOfcAuxDialog}
        toggleShowDialog={() => setShowYaFueIngresadoOfcAuxDialog(!showYaFueIngresadoOfcAuxDialog)}
        title={'Oficial auxiliar previamente ingresado'}
        onAccept={() => {
          setShowYaFueIngresadoOfcAuxDialog(false);
        }}
        onCancel={() => {}}
        hideCancelButton
        acceptText={'Ok'}
        cancelText={'No'}
        minWidth={500}
      >
        <Text className="error-message" variant="medium">
          Ya fue ingresado un oficial auxiliar con ese numero de documento
        </Text>
      </DialogTemplate>
      <div className="ms-Grid-col ms-sm12 mt-2 padding-1">
        <div className="ms-Grid-row ">
          <div className="ms-Grid-col ms-sm12  text-center">
            <Text variant="mediumPlus" style={{ fontWeight: 500 }} block>
              {club_nombre}
            </Text>
          </div>
        </div>
      </div>
      <div className="ms-Grid-col ms-sm6 ms-Grid padding-1 mt-2">
        <div className="ms-motion-slideDownIn">
          <div className="ms-Grid-row ">
            <div className="ms-Grid-col ms-sm12  text-center">
              <div className="ms-Grid-col ms-sm2 text-center mt-2">
                <Text variant="mediumPlus" style={{ fontWeight: 500 }} block>
                  Dorsal
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm10 text-center  mt-2">
                <Text variant="mediumPlus" style={{ fontWeight: 500 }} block>
                  Jugadores
                </Text>
              </div>

              {form
                .getJugadoresByEquipo(String(equipoId))
                .sort((a, b) => Jugador.sortByFullameFn(a, b))
                .map((jugador, i) => {
                  return (
                    <div key={i} className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm2 mt-2">
                        <TextField
                          key={i}
                          // @ts-ignore
                          componentRef={(el) => (inputRefs.current[i] = el)}
                          value={form.getDorsalBy(String(jugador.getId()))}
                          onChange={(_e, nv) => changeDorsalByJugador(String(jugador.getId()), nv!)}
                          styles={{
                            fieldGroup: {
                              height: 77,
                              background: hasRepeated(
                                String(jugador.getId()),
                                +form.getDorsalBy(String(jugador.getId())),
                                equipoId
                              )
                                ? '#ffdbdb'
                                : 'white',
                            },
                            field: { fontSize: 45, textAlign: 'center' },
                          }}
                          disabled={
                            !jugador.getActivo() ||
                            jugador.estaSuspendido() ||
                            (form
                              .getListPlanillaPartidoJugadoresByEquipo(equipoId)
                              .filter((ppj) => !!ppj.getDorsal()).length === MAX_HANDBALL_PLAYERS_PER_TEAM &&
                              !!!form.getDorsalBy(String(jugador.getId())))
                          }
                          onBlur={() => {
                            const isValid = sameNumberChecker(i);
                          }}
                          errorMessage={
                            hasRepeated(
                              String(jugador.getId()),
                              +form.getDorsalBy(String(jugador.getId())),
                              equipoId
                            )
                              ? 'Dorsal repetido'
                              : ''
                          }
                        />
                      </div>

                      <JugadorCardForConfeccionOffline
                        jugador={jugador}
                        system={system}
                        deleteJugador={deleteJugador}
                        disabledApparience={!!!form.getDorsalBy(String(jugador.getId()))}
                        suspendedApparience={jugador.estaSuspendido()}
                        inactiveApparience={!jugador.getActivo()}
                      ></JugadorCardForConfeccionOffline>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="ms-Grid-col ms-sm6 mt-2">
        <div className="bg-white-h100 ms-depth-4 padding-1">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                Jugadores
              </Text>
            </div>
          </div>
          <div className="ms-Grid-row  mt-4">
            <div className="ms-Grid-col ms-sm12">
              <DefaultButton
                onClick={() => {
                  setShowFormJugador(true);
                }}
                iconProps={{ iconName: 'Add' }}
              >
                Agregar jugador
              </DefaultButton>
            </div>
          </div>
          {showFormJugador && (
            <>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm3">
                  <InputField
                    input={jugadorOfflineNombreInput}
                    label="Nombre (*)"
                    onBlur={() => onBlurForm(form.getJugadorAAgregarForm(), setJugadorFormIsValid)}
                  />
                </div>
                <div className="ms-Grid-col ms-sm3">
                  <InputField
                    input={jugadorOfflineApellidoInput}
                    label="Apellido (*)"
                    onBlur={() => onBlurForm(form.getJugadorAAgregarForm(), setJugadorFormIsValid)}
                  />
                </div>
                <div className="ms-Grid-col ms-sm3">
                  <ComboBoxInput
                    input={jugadorOfflineTipoDocInput}
                    label="Tipo documento (*)"
                    onBlur={() => onBlurForm(form.getJugadorAAgregarForm(), setJugadorFormIsValid)}
                    options={tipoDocumentoOptions}
                    selectedKey={jugadorOfflineTipoDocInput.getValue()}
                  />
                </div>
                <div className="ms-Grid-col ms-sm3">
                  <InputField
                    input={jugadorOfflineNroDocInput}
                    label="Numero documento (*)"
                    onBlur={() => onBlurForm(form.getJugadorAAgregarForm(), setJugadorFormIsValid)}
                  />
                </div>
              </div>
              <div className="ms-Grid-row mt-2">
                <div className="ms-Grid-col ms-sm2">
                  <PrimaryButton
                    disabled={!jugadorFormIsValid}
                    onClick={onClickAddJugador}
                    iconProps={{ iconName: 'Save' }}
                  >
                    Guardar
                  </PrimaryButton>
                </div>
                <div className="ms-Grid-col ms-sm2">
                  <DefaultButton onClick={cancelJugador} iconProps={{ iconName: 'Cancel' }}>
                    Cancelar
                  </DefaultButton>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="ms-motion-slideDownIn">
          <div className="bg-white-h100 ms-depth-4 padding-1 mt-2">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                  Oficial A
                </Text>
              </div>
            </div>
            {!oficialesInput
              .getValue()
              .filter((o: PlanillaPartidoOficial) => o.isActive() && +o.getEqid() === +equipoId)[0] && (
              <div className="ms-Grid-row mt-2">
                <div className="ms-Grid-col ms-sm12">
                  {/* <Label>Agregar oficial</Label> */}

                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm3">
                      <InputField
                        input={oficialOfflineNombreInput}
                        label="Nombre (*)"
                        onBlur={() => onBlurForm(form.getOficialAAgregarForm(), setOficialFormIsValid)}
                      />
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <InputField
                        input={oficialOfflineApellidoInput}
                        label="Apellido (*)"
                        onBlur={() => onBlurForm(form.getOficialAAgregarForm(), setOficialFormIsValid)}
                      />
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <ComboBoxInput
                        input={oficialOfflineTipoDocInput}
                        label="Tipo documento (*)"
                        onBlur={() => onBlurForm(form.getOficialAAgregarForm(), setOficialFormIsValid)}
                        options={tipoDocumentoOptions}
                        selectedKey={oficialOfflineTipoDocInput.getValue()}
                      />
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <InputField
                        input={oficialOfflineNroDocInput}
                        label="Numero documento (*)"
                        onBlur={() => onBlurForm(form.getOficialAAgregarForm(), setOficialFormIsValid)}
                      />
                    </div>
                  </div>
                  <div className="ms-Grid-row  mt-2">
                    <div className="ms-Grid-col ms-sm12">
                      <DefaultButton
                        onClick={onClickAddOficial}
                        iconProps={{ iconName: 'Add' }}
                        disabled={!oficialFormIsValid}
                      >
                        Agregar Oficial
                      </DefaultButton>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {oficialesInput
              .getValue()
              .filter((o: PlanillaPartidoOficial) => o.isActive() && +o.getEqid() === +equipoId)[0] && (
              <div className="ms-Grid-row mt-2">
                <div className="ms-Grid-col ms-sm12">
                  <EntrenadorCardForConfeccion
                    entrenador={oficialesInput
                      .getValue()
                      .filter((o: PlanillaPartidoOficial) => o.isActive() && +o.getEqid() === +equipoId)[0]
                      .getEntrenador()}
                    system={system}
                    deleteEntrenador={deleteEntrenador}
                  ></EntrenadorCardForConfeccion>
                </div>
              </div>
            )}
          </div>
          <div className="bg-white-h100 ms-depth-4 padding-1 mt-2">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <Text variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
                  Oficiales auxiliares
                </Text>
              </div>
            </div>
            <div className="ms-Grid-row mt-4">
              <div className="ms-Grid-col ms-sm12">
                <DefaultButton
                  onClick={() => {
                    setShowFormAuxiliar(true);
                  }}
                  iconProps={{ iconName: 'Add' }}
                  disabled={
                    oficialesAuxiliaresInput
                      .getValue()
                      .filter((oa: PlanillaPartidoOficialAuxiliar) => +oa.getEqid()! === +equipoId).length ===
                    MAX_OFICIALES_AUXILIARES
                  }
                >
                  Agregar oficial auxiliar
                </DefaultButton>
              </div>
            </div>
            {showFormAuxiliar && (
              <>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm3">
                    <InputField
                      input={oficialAuxiliarOfflineNombreInput}
                      label="Nombre (*)"
                      onBlur={() =>
                        onBlurForm(form.getOficialAuxiliarAAgregarForm(), setOficialAuxiliarFormIsValid)
                      }
                    />
                  </div>
                  <div className="ms-Grid-col ms-sm3">
                    <InputField
                      input={oficialAuxiliarOfflineApellidoInput}
                      label="Apellido (*)"
                      onBlur={() =>
                        onBlurForm(form.getOficialAuxiliarAAgregarForm(), setOficialAuxiliarFormIsValid)
                      }
                    />
                  </div>
                  <div className="ms-Grid-col ms-sm3">
                    <InputField
                      input={oficialAuxiliarOfflineNroDocInput}
                      label="Numero documento (*)"
                      onBlur={() =>
                        onBlurForm(form.getOficialAuxiliarAAgregarForm(), setOficialAuxiliarFormIsValid)
                      }
                    />
                  </div>
                  <div className="ms-Grid-col ms-sm3">
                    <ComboBoxInput
                      input={oficialAuxiliarOfflineOrdenInput}
                      label="Orden"
                      onBlur={() =>
                        onBlurForm(form.getOficialAuxiliarAAgregarForm(), setOficialAuxiliarFormIsValid)
                      }
                      options={getOrdenesDisponibles()}
                      selectedKey={oficialAuxiliarOfflineOrdenInput.getValue()}
                    />
                  </div>
                </div>
                <div className="ms-Grid-row mt-2">
                  <div className="ms-Grid-col ms-sm2">
                    <PrimaryButton
                      disabled={!oficialAuxiliarFormIsValid}
                      onClick={saveAuxiliar}
                      iconProps={{ iconName: 'Save' }}
                    >
                      Guardar
                    </PrimaryButton>
                  </div>
                  <div className="ms-Grid-col ms-sm2">
                    <DefaultButton onClick={cancelAuxiliar} iconProps={{ iconName: 'Cancel' }}>
                      Cancelar
                    </DefaultButton>
                  </div>
                </div>
              </>
            )}
            {form.getOficialesAuxiliaresByEquipoId(equipoId).length > 0 && (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <DetailsList
                    items={form.getOficialesAuxiliaresByEquipoId(equipoId)}
                    selectionMode={SelectionMode.none}
                    columns={columnsAux}
                    onShouldVirtualize={() => false}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default ConfeccionPlanillaPartidoTeamOffline;
